import React, { useState } from 'react';

import MuiTextField from '@material-ui/core/TextField';
import MuiBox from '@material-ui/core/Box';
import MuiButton from '@material-ui/core/Button';

function EditISRC({ isrc, onSave, trackId }) {
  const [formISRC, setFormISRC] = useState(isrc || '');

  return (
    <MuiBox>
      <MuiTextField value={formISRC} onChange={({ target: { value } }) => setFormISRC(value)} />
      <MuiButton variant="contained" size="small" onClick={() => onSave({ trackId, isrc: formISRC })}>
        Save ISRC
      </MuiButton>
    </MuiBox>
  );
}

export default EditISRC;
